import { css } from "@emotion/react";

const Z_INDEXES = {
  CHECK_ICON: 20,
  INPUT: 30,
  SQUARE: 10,
} as const;

export const rootStyle = css`
  display: inline-block;
  height: 20px;
  position: relative;
  width: 20px;
`;

const centerStyle = css`
  bottom: 0;
  left: 0;
  margin: auto;
  position: absolute;
  right: 0;
  top: 0;
`;

export const inputStyle = css`
  bottom: 0;
  cursor: pointer;
  left: 0;
  opacity: 0;
  position: absolute;
  right: 0;
  top: 0;
  z-index: ${Z_INDEXES.INPUT};

  & ~ svg {
    color: transparent;
    display: block;
    height: 10px;
    pointer-events: none;
    width: 14px;
    z-index: ${Z_INDEXES.CHECK_ICON};
    ${centerStyle};
  }

  &:checked ~ svg {
    color: #f5f5f5;
  }
`;

export const squareStyle = css`
  background-color: #fff;
  border-color: #757575;
  border-radius: 4px;
  border-style: solid;
  border-width: 1px;
  display: block;
  z-index: ${Z_INDEXES.SQUARE};
  ${centerStyle};

  input:checked ~ & {
    background-color: #2c2c2c;
    border-color: #2c2c2c;
  }
`;
